<template>
  <el-main>
    <div v-if="flushFlag">
      <i class="el-icon-loading"></i>
      <span>视频加载中(若提示获取曲谱图片失败，数据不会丢失，稍后即可查看)。。。</span>
    </div>
    <div v-else class="content-detail-container">
      <el-form ref="contentDetail" label-width="9rem">
        <el-form-item label="乐器名称" required>
          <el-input v-model="drumName" disabled></el-input>
        </el-form-item>
        <el-form-item label="曲册名称" required>
          <el-input v-model="albumName" disabled></el-input>
        </el-form-item>
        <el-form-item label="章节名称" required>
          <el-input v-model="chapterName" disabled></el-input>
        </el-form-item>
        <el-form-item label="标题" required>
          <el-input v-model="contentDetail.title" :disabled="!showContentEditFlag"></el-input>
        </el-form-item>
        <el-form-item label="内容描述" required>
          <el-input v-model="contentDetail.description" :disabled="!showContentEditFlag"></el-input>
        </el-form-item>
        <el-form-item label="是否为考级示范" required>
          <el-radio-group v-model="contentDetail.isFree">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <!-- 2022-10-13 父课程不再显示视频 -->
      <!-- <div class="opern">
        <p class="video-label">视频  <el-button v-if="showContentEditFlag" class="dialog-video-btn" type="primary" size="small" @click="updateVideo"> 更新视频 </el-button></p>
        <div v-if="contentDetail.isReady&&contentDetail.videoId" class="video">
          <div class="prism-player" id="J_prismPlayer">

          </div>
        </div>
        <div v-else-if="!contentDetail.isReady">
          <div><i class="el-icon-loading"></i>视频正在加载中，请稍后查看</div>
        </div>
        <div v-else>
          <div>您还未上传视频，请上传</div>
        </div>
      </div> -->

      <!-- 视频封面 -->
      <div class="opern">
        <p>视频封面</p>
        <div v-if="showContentEditFlag" class="upload">
          <input type="file" class="imgUpload" @change="coverChange($event)">
          <el-button @click.stop="coverImgUpload" :disabled="startCoverUploadFlag" type="primary" size="small">开始上传
          </el-button>
        </div>
        <!--上传预览-->
        <img v-if="localCoverImgUrl" :src="localCoverImgUrl" alt="" class="cover-img">
        <img v-if="contentDetail.coverUrl" :src="contentDetail.coverUrl" alt="" class="cover-img">
      </div>
      <!-- 曲谱 -->
      <div class="opern">
        <p>曲谱图</p>
        <div v-if="showContentEditFlag" class="upload">
          <input type="file" id="imgUpload" @change="imgChange($event)">
          <el-button @click.stop="addImgUpload" :disabled="startImgUploadFlag" type="primary" size="small">开始上传
          </el-button>
        </div>
        <!--上传预览-->
        <img v-if="localImgUrl" :src="localImgUrl" alt="" class="local-img">
        <img :src="contentDetail.opernUrl" alt="" class="opernImg">
      </div>
      <!-- 2022-10-13 父课程增加子课程显示，允许更新子课程的视频 -->
      <div class="opern opern-con">
        <p>曲速列表</p>
        <div v-if="contentId && contentDetail.id">
          <content-list :pid="contentId"
            @showAddContent="dialogVisible = true"
            @showContentEdit="editVideo"
          ></content-list>
        </div>
      </div>
      <div class="save-btn">
        <el-button type="primary" class="primary theme-btn" @click="saveUpdate" v-if="showContentEditFlag">保存修改</el-button>
      </div>
    </div>
    <!-- 批量新增视频 -->
    <el-dialog
        title="视频上传"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :destroy-on-close="true"
        width="30%"
        :before-close="closeDialog"
      >
        <add-videos ref="addVideos" :course-info="contentDetail" @change="(o) => {uploading = o}" @end="uploadEnd"></add-videos>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" v-loading="uploading" @click="uploadStart">开始上传</el-button>
          <el-button type="primary" @click="dialogVisible = false">取 消</el-button>
        </span>
      </el-dialog>
    <!-- 单个新增视频 -->
    <dialogVideo v-if="dialogVideoFlag" :content-info="childDetail" @closeDialog="closeDialog"></dialogVideo>
  </el-main>
</template>

<script>
  import DialogVideo from "../common/DialogVideo";
  import AddVideos from '@/components/practiceManage/AddVideos';
  import ContentList from '@/components/practiceManage/ContentList';

  var initInfo = {
    categoryId: null,
    categoryName: "",
    coverUrl: "",
    createTime: "",
    description: "",
    isFree: 0,
    fullCategoryId: "",
    fullCategoryName: "",
    id: 0,
    opernUrl: "",
    playAuth: "",
    title: "",
    videoDuration: null,
    videoId: ""
  }
  export default {
    name: "ContentDetail",
    props: ['contentId', 'showContentEditFlag'],
    components:{
      dialogVideo: DialogVideo,
      AddVideos,
      ContentList
    },
    data() {
      return {
        /**
          categoryId (integer, optional): 章节编号 ,
          categoryName (string, optional): 类目名称 ,
          coverUrl (string, optional): 视频封面 ,
          createTime (string, optional): 上传时间 ,
          description (string, optional): 内容描述 ,
          fullCategoryId (string, optional): 全类目编号 ,
          fullCategoryName (string, optional): 全类目名称 ,
          id (integer, optional): 内容编号 ,
          opernUrl (string, optional): 曲谱图地址 ,
          playAuth (string, optional): 视频播放凭证 ,
          title (string, optional): 内容标题 ,
          videoDuration (number, optional): 视频时长，单位秒 ,
          videoId (string, optional): 视频编号
        **/

        contentDetail: {
          categoryId: null,
          categoryName: "",
          coverUrl: "",
          createTime: "",
          description: "",
          isFree: 0,
          fullCategoryId: "",
          fullCategoryName: "",
          id: 0,
          opernUrl: "",
          playAuth: "",
          title: "",
          videoDuration: null,
          videoId: ""
        },
        childDetail: {},

        drumName: '',
        albumName: '',
        chapterName: '',


        // 图片上传 --------------------------------
        img_uploader: "",
        // 上传文件对象
        img_file: null,
        cover_file:null,
        // 图片上传按钮控制
        startImgUploadFlag: true,
        startCoverUploadFlag: true,
        // 图片上传的进度，
        imgProgress: 0,
        // 图片凭证返回结果
        imgResult: '',

      // 本地路径
        localImgUrl:"",
        localCoverImgUrl:"",

      //  视频上传
        dialogVideoFlag:false,
        dialogVisible: false,
        showAddVideo:false,
        // 加载中
        flushFlag:false,
        uploading:false
      }
    },
    created() {
      // 获取机构详情
      if(this.showContentEditFlag){
        this.showAddVideo = true
      }
      this.getContentDetail();
    },

    methods: {
      // 获取详情
      getContentDetail() {
        this.contentDetail = Object.assign({}, initInfo);
        let param = {
          id: this.contentId
        };
        let res = this.$api.get('/content/details.json', param);
        res.then(success => {
          if (success.code === 200) {
            this.contentDetail = success.data;
            // 获取类目名称
            this.drumName = success.data.fullCategoryName.split(',')[0];
            this.albumName = success.data.fullCategoryName.split(',')[1];
            this.chapterName = success.data.fullCategoryName.split(',')[2];

            // 2022-10-13 优化返回数据，填补不同字段保证新增视频时顺利
            this.$set(this.contentDetail, "cid", success.data.categoryId);
            this.$set(this.contentDetail, "imageId", success.data.opernUrl);
            this.$set(this.contentDetail, "parentResourceId", success.data.id);
            this.$set(this.contentDetail, "isFree", ~~success.data.isFree);

            //   播放视频
            setTimeout(()=>{
              if(this.contentDetail.isReady && this.contentDetail.videoId) {
                this.play(this.contentDetail.videoId, this.contentDetail.playAuth, this.contentDetail.coverUrl)
              }
            })

            console.log("success.code", this.contentDetail);
          } else {
            this.$message.error("内容详情获取失败！")
          }
        }, error => {
          this.$message.error(error.msg)
        })
          .catch(err => {
            this.$message.error("内容详情获取异常！")
          })
      },
      // 视频播放
      play(vid, playauth, cover) {
        let player = new Aliplayer({
          id: 'J_prismPlayer',
          width: '100%',
          autoplay: true,  // 自动播放

          //播放方式二：点播用户推荐
          vid: vid,
          playauth: playauth,
          cover: cover,
          // encryptType:1, //当播放私有加密流时需要设置。

        }, function (player) {
          console.log('播放器创建好了。')
        });

      },

      // 图片上传开始-------------------------------------

      // 选择图片文件
      imgChange(file) {
        // 文件改变  禁用上传按钮  文件类型正确再打开
        this.startImgUploadFlag = true;
        // 取消当前预览
        this.localImgUrl='';
        this.img_file = file.target.files[0];
        if (!this.img_file) {
          return this.$message.error('请先选择需要上传的图片文件!')
        }
        if(this.img_file.size>548576){
          return this.$message.error("请控制图片尺寸在500KB以下！");
        }
        // 获取文件预览路径  预览
        let imgUrl = this.tools.getObjectURL(this.img_file);
        if(imgUrl){
          this.localImgUrl=imgUrl;
        }


        let userData = '{"Vod":{}}';

        if (this.img_uploader) {
          // 停止上传
          this.img_uploader.stopUpload();
          // 进度置零
          this.imgProgress = 0;
        }
        //创建对象
        this.img_uploader = this.getImgUpload();
        // 添加文件
        this.img_uploader.addFile(this.img_file, null, null, null, userData);
      },
      coverChange(file) {
        this.startCoverUploadFlag = true
        // 取消预览
        this.localCoverImgUrl = '';
        this.cover_file = file.target.files[0];

        if (!this.cover_file) {
          return this.$message.error('请选择需要上传的视频封面!')
        }
        if(this.cover_file.size>548576){
          return this.$message.error("请控制图片尺寸在500KB以下！");
        }
        // 选择图片可以上传
        this.startCoverUploadFlag = false;
        // 本地预览
        let imgUrl = this.tools.getObjectURL(this.cover_file);
        if (imgUrl) {
          this.localCoverImgUrl = imgUrl;
        }
      },
      // 获取上传对象
      getImgUpload() {
        let that = this;
        let img_uploader = new AliyunUpload.Vod({
          //阿里账号ID，必须有值 ，值的来源https://help.aliyun.com/knowledge_detail/37196.html
          userId: "1689030746142927",
          region: 'cn-shanghai',
          //分片大小默认1M，不能小于100K
          partSize: 1048576,
          //并行上传分片个数，默认5
          parallel: 5,
          //网络原因失败时，重新上传次数，默认为3
          retryCount: 3,
          //网络原因失败时，重新上传间隔时间，默认为2秒
          retryDuration: 2,
          //是否上报上传日志到点播，默认为true
          enableUploadProgress: true,
          // 添加文件成功
          addFileSuccess: function (uploadInfo) {
            if (uploadInfo.file.type === "image/jpeg" || uploadInfo.file.type === "image/png" || uploadInfo.file.type === "image/jpg") {
              // 开启文件上传
              that.startImgUploadFlag = false;
            } else {
              // 文件类型不对按钮禁用
              that.$message.error("仅支持JPEG、PNG、JPG图片文件: " + uploadInfo.file.type)
            }
          },
          // 开始上传
          onUploadstarted: function (uploadInfo) {
            //uploadAuth上传方式, 需要根据uploadInfo.videoId是否有值，调用点播的不同接口获取uploadauth和uploadAddress，如果videoId有值，调用刷新视频上传凭证接口，否则调用创建视频上传凭证接口
            //获取文件拓展名 str.split(".")[1]
            let fileExt = uploadInfo.file.name.split(".");
            fileExt = fileExt[fileExt.length - 1];
            // 不管 videoId 存不存在 都获取凭证
            let params = {
              title: that.contentDetail.title,
              fileExt: fileExt
            };
            that.$api.get('/content/upload/image/auth.json', params).then(success => {
              // 保存结果
              that.imgResult = success.data;
              //  设置凭证   从点播服务获取的uploadAuth、uploadAddress和videoId,设置到SDK里
              let uploadAuth = success.data.uploadAuth;
              let imageId = success.data.imageId;
              let uploadAddress = success.data.uploadAddress;
              img_uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress, imageId);
            }, error => {
              that.$message.error(error.msg)
            })
              .catch(err => {
                that.$message.error("凭证获取异常！")
              })
          },
          // 文件上传成功
          'onUploadSucceed': function (uploadInfo) {
            that.$message({
              message: '上传成功!',
              type: 'success'
            });
            // 把文件对象置空  上传对象置空
            that.img_uploader = null;
            that.img_file = null;
            //取消预览
            that.contentDetail.opernUrl =that.localImgUrl
            that.localImgUrl='';
            // console.log("onUploadSucceed: " + uploadInfo.file.name + ", endpoint:" + uploadInfo.endpoint + ", bucket:" + uploadInfo.bucket + ", object:" + uploadInfo.object);
          },
          // 文件上传失败
          'onUploadFailed': function (uploadInfo, code, message) {
            // console.log("onUploadFailed: file:" + uploadInfo.file.name + ",code:" + code + ", message:" + message);
          },
          // 文件上传进度，单位：字节
          'onUploadProgress': function (uploadInfo, totalSize, loadedPercent) {
            let progress = Math.ceil(loadedPercent * 100);
            that.imgProgress = progress;
            // console.log("onUploadProgress:file:" + uploadInfo.file.name + ", fileSize:" + totalSize + ", percent:" + Math.ceil(loadedPercent * 100) + "%");
          },
          //全部文件上传结束
          'onUploadEnd': function (uploadInfo) {
            // console.log("onUploadEnd: uploaded all the files");
          }
        });
        return img_uploader;
      },

      // 点击图片上传
      addImgUpload() {
        if (!this.img_file) {
          return this.$message.error("请先选择图片文件！");
        }
        // 上传对象存在调用 startUpload 方法, 开始上传
        if (this.img_uploader !== null) {
          this.img_uploader.startUpload();
        }
      },
      coverImgUpload() {
        if (!this.cover_file) {
          return this.$message.error("请先选择图片文件！");
        }
        // //  格式化文件数据
        let form = new FormData();
        form.append('file', this.cover_file);
        let res = this.$api.post('/content/image/upload.json', form);
        res.then(success => { // 成功才会有数据
          this.$message({
            message: '上传成功！',
            type: 'success'
          });
          this.contentDetail.coverUrl = success.data;
        //  取消本地预览
          this.localCoverImgUrl=''
        }, err => {
          this.$message.error(err.msg);
        })
                .catch(err => {
                  this.$message.error('上传异常！');
                });
      },
      // 图片上传结束----------------------------------------

      //   保存修改
      saveUpdate() {
        if(!this.contentDetail.title){
          return this.$message.error("标题不能为空！");
        }
        if(!this.contentDetail.title){
          return this.$message.error("内容描述不能为空！");
        }
        if(!this.contentDetail.opernUrl){
          return this.$message.error("请上传曲谱！");
        }
        let param = {
          cid: this.contentDetail.categoryId,  //章节编号
          description: this.contentDetail.description, //描述
          id: this.contentDetail.id,  //  内容编号
          imageId: this.imgResult.imageId ? this.imgResult.imageId : '', // 曲谱编号
          title: this.contentDetail.title, //标题
          coverUrl: this.contentDetail.coverUrl,  // 视频封面
          isFree: this.contentDetail.isFree  // 是否考级示范
        };
        this.$api.put('/content/modify.json', param)
          .then(res => {
            this.$message({
              message: '修改成功!',
              type: 'success'
            });
            //    获取数据
            this.$emit('goBack')
            // this.getContentDetail()
          }, err => {
            this.$message.error(err.msg)
          })
          .catch(err => {
            this.$message.error("修改异常!");
          })

      },

      //上传视频
      handleAddVideo(index,row){
        this.contentId = row.id
        this.dialogVideoFlag = true
      },
      updateVideo(){
        this.dialogVideoFlag = true
      },

      // 关闭弹框
      closeDialog(){
        // if(this.dialogVisible) {
          this.dialogVisible = false;
          // return;
        // }
        this.dialogVideoFlag = false;
        this.flushFlag = true;
        setTimeout(()=>{
          this.getContentDetail();
          this.flushFlag = false;
        }, 20000)
      },

      // 2022-10-13 视频更新方法修改
      uploadStart() {
        this.$refs.addVideos.uploadStart();
      },
      uploadEnd() {
        this.closeDialog();
        this.contentDetail.id = 0;
        this.getContentDetail();
      },
      /** 更新视频 */
      editVideo(row) {
        this.dialogVideoFlag = true;
        this.childDetail = Object.assign(this.contentDetail, row);
        this.$set(this.childDetail, "speed", row.speed);
      },
    },

  }
</script>

<style scoped>

  .el-main {
    display: flex;
    justify-content: center;
  }

  .content-detail-container {
    width: 90%;
    display: flex;
    flex-direction: column;
    align-items: center;

  }

  /* .el-form {
    width: 400px;
    border: #8c939d 1px solid;
  } */

  .opernImg {
    display: inline-block;
    width: 500px;
  }

  /*本地图片预览*/
  .local-img{
    width: 120px;
    height: 90px;
  }

  .video {
    width: 600px;
    height: 300px;
  }

  .video-label {
    margin-top: 10px;

  }

  .opern {
    width: 600px;
    margin-bottom: 20px;
  }
  .opern-con {
    width: 100%;
  }

  .opern > p {
    margin-bottom: 10px;
    font-weight: bold;
  }

  .upload {
    margin-bottom: 10px;
  }

  /*保存按钮*/
  .save-btn {
    width: 100%;
    display: flex;
    justify-content: center;
    /*flex-direction: row-reverse;*/
  }
  .primary{
    background-color: #ff8750;
    border: 0;
    box-shadow: none;
  }
  .progress{
    font-size: 14px;
  }
  .cover-img{
    width: 600px;
    height: 340px;
  }
  .dialog-video-btn{
    margin-left: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/practiceManage/ContentDetail.vue